import { render, staticRenderFns } from "./BridgesAndTunnels.vue?vue&type=template&id=beae2dd6&scoped=true"
import script from "./BridgesAndTunnels.vue?vue&type=script&lang=js"
export * from "./BridgesAndTunnels.vue?vue&type=script&lang=js"
import style0 from "./BridgesAndTunnels.vue?vue&type=style&index=0&id=beae2dd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beae2dd6",
  null
  
)

export default component.exports